import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const CellMerge = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M6.773 8.354a.5.5 0 0 0 0-.708l-2.5-2.5a.5.5 0 1 0-.707.708L5.213 7.5H1.5a.5.5 0 0 0 0 1h3.713l-1.647 1.646a.5.5 0 0 0 .707.708l2.5-2.5Zm2.454-.708a.5.5 0 0 0 0 .708l2.5 2.5a.5.5 0 0 0 .707-.708L10.787 8.5H14.5a.5.5 0 0 0 0-1h-3.713l1.647-1.646a.5.5 0 1 0-.707-.708l-2.5 2.5ZM1 3v3h1V3h4V2H2a1 1 0 0 0-1 1Zm9-1v1h4v3h1V3a1 1 0 0 0-1-1h-4ZM6 13H2v-3H1v3a1 1 0 0 0 1 1h4v-1Zm4 1h4a1 1 0 0 0 1-1v-3h-1v3h-4v1Z"
        fill={color}
      />
    </svg>
  )
})

export default CellMerge
